module.exports = __webpack_public_path__ + "static/img/scat.9a2c9df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/scat.png
// module id = Yx+d
// module chunks = 0